import { LMEUserCRM } from "../LMEUserCRM";
import { LMEUserIntegrations } from "../LMEUserIntegrations";
import { LMEUserMapping } from "../LMEUserMapping";
import { LMEUserOperations } from "../LMEUserOperations";
import { LMEUserTemplates } from "../LMEUserTemplates";
import { Button, Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUser extends Layout {
    buttonCopyUser: Button;
    buttonSetWebPassword: Button;
    buttonUserAgencies: Button;
    buttonUserGroups: Button;
    checkboxAgent: Checkbox;
    checkboxEnableAlerts: Checkbox;
    dataheaderLMEUser: DataHeader;
    layoutLMEUserBackOffice: Layout;
    layoutLMEUserCRM: LMEUserCRM;
    layoutLMEUserIntegrations: LMEUserIntegrations;
    layoutLMEUserMapping: LMEUserMapping;
    layoutLMEUserOperations: LMEUserOperations;
    layoutLMEUserTemplates: LMEUserTemplates;
    layoutUserGeneral: Layout;
    layoutUserLogin: Layout;
    panelAdminButtons: Panel;
    sourceAgencyLink: DataSource;
    sourceUserRecognizedDevice: DataSource;
    sourceUserSettings: DataSource;
    tabBackOffice: Tab;
    tabCRM: Tab;
    tabGeneral: Tab;
    tabIntegrationServices: Tab;
    tabLogin: Tab;
    tabMapping: Tab;
    tabOperations: Tab;
    tabRapidAlert: Tab;
    tabResponsibility: Tab;
    tabTemplates: Tab;
    tabsetUsers: Tabset;
    textboxSortOrder: Textbox;
    textboxSystemTray: Textbox;
}
